import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, FileTextIcon, RefreshCwIcon, SendIcon } from 'lucide-react';
interface PrescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'refill' | 'transfer';
}
export function PrescriptionModal({
  isOpen,
  onClose,
  type
}: PrescriptionModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      onClose();
    }, 3000);
  };
  return <AnimatePresence data-id="element-190">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100]" data-id="element-191" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed inset-0 m-auto w-full max-w-lg h-fit bg-white rounded-3xl shadow-2xl z-[101] overflow-hidden" data-id="element-192">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-193">
              <div className="flex items-center gap-3" data-id="element-194">
                <div className="w-10 h-10 bg-clinical-blue/10 rounded-xl flex items-center justify-center text-clinical-blue" data-id="element-195">
                  {type === 'refill' ? <RefreshCwIcon className="w-5 h-5" data-id="element-196" /> : <FileTextIcon className="w-5 h-5" data-id="element-197" />}
                </div>
                <div data-id="element-198">
                  <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight" data-id="element-199">
                    {type === 'refill' ? 'Refill Prescription' : 'Transfer Prescription'}
                  </h2>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-200">
                    Secure Request Form
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors" data-id="element-201">
                <XIcon className="w-5 h-5 text-slate-400" data-id="element-202" />
              </button>
            </div>

            <div className="p-8" data-id="element-203">
              {submitted ? <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-center py-12" data-id="element-204">
                  <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-205">
                    <SendIcon className="w-8 h-8" data-id="element-206" />
                  </div>
                  <h3 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight" data-id="element-207">
                    Request Sent!
                  </h3>
                  <p className="text-slate-500" data-id="element-208">
                    Our pharmacy team will process your request and contact you
                    shortly.
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-209">
                  <div className="grid grid-cols-2 gap-4" data-id="element-210">
                    <div className="space-y-2" data-id="element-211">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-212">
                        First Name
                      </label>
                      <input required type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-213" />
                    </div>
                    <div className="space-y-2" data-id="element-214">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-215">
                        Last Name
                      </label>
                      <input required type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-216" />
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-217">
                    <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-218">
                      Date of Birth
                    </label>
                    <input required type="date" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-219" />
                  </div>

                  {type === 'refill' ? <div className="space-y-2" data-id="element-220">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-221">
                        Rx Number(s)
                      </label>
                      <input required placeholder="e.g. 1234567, 8901234" type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-222" />
                    </div> : <>
                      <div className="space-y-2" data-id="element-223">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-224">
                          Current Pharmacy Name
                        </label>
                        <input required type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-225" />
                      </div>
                      <div className="space-y-2" data-id="element-226">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-227">
                          Current Pharmacy Phone
                        </label>
                        <input required type="tel" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-228" />
                      </div>
                    </>}

                  <div className="pt-4" data-id="element-229">
                    <button type="submit" className="w-full bg-clinical-blue text-white font-black py-4 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-230">
                      Submit Request
                    </button>
                  </div>
                </form>}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}